import { Colors } from '@/config/interfaces'

export const lightColors: Colors = {
  primary: '#002340',
  checkboxColor: '#002340',
  secondary: '#B4FF00',
  appDefault: '#F2F4F5',
  darkblue: '#424663',
  black: '#0C1026',
  white: '#FFFFFF',
  itemBackground: '#ffffff',
  textBackground: '#FFFFFF',
  lightGray1: '#F1F1F1',
  lightGray2: '#E9E9E9',
  darkGray: '#4D6579',
  textBlack: '#1A1A1A',
  purple: '#B2C3FF',
  blue: '#A3DEFF',
  turquoise: '#9CE7F5',
  green: '#B0F0B2',
  yellow: '#FDF192',
  orange: '#FFCB96',
  red: '#FFB4B4',
  pink: '#FFBCDE',
  lightPurple: '#E6E9F4',
  lightBlue: '#E6EEF4',
  lightTurquoise: '#EAF3F5',
  lightGreen: '#EDF4EF',
  lightYellow: '#F7F5ED',
  lightOrange: '#F7F2ED',
  lightRed: '#F7EDED',
  lightPink: '#F8F0F4',
  activeBorderColor: '#19AAF8',
  btnColor: '#002340',
  switchColor: '#002340',
  slideColor: '#61a4ba',
  headerMessageBlue: '#C4DFE9'
}
export const darkColors: Colors = {
  primary: '#002340',
  secondary: '#B4FF00',
  appDefault: '#010F1A',
  darkblue: '#424663',
  white: '#E5E9EC',
  itemBackground: '#00182C',
  textBackground: '#010F1A',
  textColor: '#E5E9EC',
  checkboxColor: '#E5E9EC',
  lightGray1: '#435370',
  lightGray2: '#435370',
  btnColor: '#B4FF00',
  switchColor: '#54BF78',
  slideColor: '#61a4ba',
  headerMessageBlue: '#C4DFE9'

}

export const ysveColors: Colors = {
  primary: '#002340',
  textColor: '#E5E9EC',
  btnColor: '#B4FF00',
  appDefault: '#00233f'

}
